import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const page = landingPages["directeur-marketing-externalise"];
if (!page) throw new Error("Missing marketing director service content");
const c = page.fr;

export const Route = createFileRoute("/directeur-marketing-externalise")({
  head: () =>
    pageHead({
      path: "/directeur-marketing-externalise",
      title: c.title,
      description: c.description,
      enPath: "/en/outsourced-marketing-director",
       crumbs: [["Services", "/services"], ["Directeur marketing externalisé", "/directeur-marketing-externalise"]],
      schemas: [
        {
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "CMO Partner",
          url: "https://www.cmopartner.fr/directeur-marketing-externalise",
          alternateName: ["Directrice marketing externalisée", "Directeur marketing externalisé", "Directeur marketing à temps partagé", "Fractional CMO", "CMO à temps partagé"],
          description: c.description,
        },
        ...landingSchemas(c, { serviceType: "Directeur marketing à temps partagé et externalisé", alternateName: ["Fractional CMO"] }),
      ],
    }),
  component: () => <LandingPage pageKey="directeur-marketing-externalise" forceLanguage="fr" />,
});
